import * as React from 'react'
import {AppSeeker} from "ui-seeker/core"
import {layoutSettings, navigations, roles, themeColors, themeOptions} from "./app/config"
import routes from "./app/RootRoutes"

import "rsuite/dist/rsuite.min.css"
import "style/_index.scss"

export default function App() {

    const appConfig = {
        themeColors: themeColors,
        themeOptions: themeOptions,
        layoutSettings: layoutSettings,
        routes: routes,
        roles: roles,
        navigations: navigations
    }

    return <AppSeeker {...appConfig} />
}